// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gdpr_container .gdpr__checkbox[data-v-4e193ee6]{width:100%;max-height:inherit;color:inherit}", ""]);
// Exports
module.exports = exports;
